import React from 'react'

import styled from 'styled-components'
import { withFormik } from 'formik'
import * as Yup from 'yup'
import { compose, withHandlers, withStateHandlers } from 'recompose'

import ViewModal from '../../components/ViewModalLogin'

import { recoverPassword } from '../../api/index'

import { Card, Label, Subtitle, LoginInput, LoginBtn } from './components'
import OverlayLoader from '../../components/OverlayLoader'

const RememberCard = styled(Card)`
  max-width: 400px;
  height: 300px;
  padding: 0px 30px;
  box-shadow: none;
`

const ErrorSubtitle = styled(Subtitle)`
  color: red;
`

const SucceedLabel = styled(Subtitle)`
  color: rgb(3, 168, 50);
`

const withRememberHandler = compose(
  withStateHandlers(
    () => ({
      succeded: false,
      error: null
    }),
    {
      setError: state => error => ({ ...state, error }),
      setSucceded: state => () => ({ ...state, succeded: true })
    }
  ),
  withHandlers({
    doRecoveryPassword: ({ setError, setSucceded }) => ({ email }) => {
      return recoverPassword({ email })
        .then(res => {
          if (res.msg) return setError(res.msg)
          setSucceded()
        })
        .catch(err => setError(err.msg))
    }
  }),
  withFormik({
    mapPropsToValues: () => ({ email: '' }),
    validationSchema: Yup.object().shape({
      email: Yup.string().email()
    }),
    handleSubmit: (values, { props, setSubmitting }) => {
      setSubmitting(true)
      props
        .doRecoveryPassword({ email: values.email })
        .then(res => setSubmitting(false))
    }
  })
)

export default withRememberHandler(
  ({
    // Formik props
    isOpen,
    onClose,
    submitForm,
    handleChange,
    handleBlur,
    values,
    errors,
    isSubmitting,
    succeded,
    error
  }) => {
    // withRememberHandler props
    return (
      <ViewModal isOpen={isOpen} onClose={onClose}>
        <RememberCard>
          <OverlayLoader isLoading={isSubmitting} />
          <Label>Recover your pasword</Label>
          <Subtitle>Please add your email</Subtitle>
          <LoginInput
            placeholder="Email"
            type="email"
            name="email"
            onChange={handleChange}
            onBlur={handleBlur}
            value={values.email}
            withError={errors.email}
          />
          {succeded && (
            <SucceedLabel>
              Please check your email to reset your password
            </SucceedLabel>
          )}
          {error && <ErrorSubtitle>{error}</ErrorSubtitle>}
          <LoginBtn onClick={() => submitForm()} disabled={isSubmitting}>
            Recover Password
          </LoginBtn>
        </RememberCard>
      </ViewModal>
    )
  }
)



// WEBPACK FOOTER //
// ./src/modules/Login/RememberModal.jsx